import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Refresh2(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "m14 15-4 4 4 4" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M18.062 8.5A7 7 0 0 1 12 19" }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "m10 9 4-4-4-4" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M5.938 15.5A7 7 0 0 1 12 5" })));
}
const Refresh2 = forwardRef(_Refresh2);
export { Refresh2 };
